<template>
  <div id="dataExport">
    <div class="header">
      <el-row style="height: 40px; line-height: 40px">
        <el-col :span="14">
          <span style="font-size: 16px; font-weight: bold; margin-right: 10px"
            >月份</span
          >
          <!--                    <el-date-picker-->
          <!--                            v-model="date"-->
          <!--                            style="width: 150px"-->
          <!--                            format="yyyy年MM月"-->
          <!--                            value-format="yyyy-MM"-->
          <!--                            type="month"-->
          <!--                            placeholder="选择月">-->
          <!--                    </el-date-picker>-->
          <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
        </el-col>
        <el-col :span="10">
          <div style="float: right">
            <span style="font-size: 16px; font-weight: bold; margin-right: 10px"
              >辖区</span
            >
            <popedom
              :handleSelectInput="handleSelectInputClick"
              :shelfData="shelfData"
            ></popedom>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div :key="indexParent" v-for="(itemParent, indexParent) in showArr">
        <div style="margin-top: 30px; font-size: 14px; color: #909399">
          {{ itemParent.name }}
        </div>
        <div class="buttonArr">
          <el-button
            :key="index"
            v-for="(item, index) in itemParent.data"
            @click="downloadDetail(item.api, item.params, item.fileName)"
            style="margin-top: 20px; margin-left: 0; margin-right: 15px"
            type="primary"
            size="small"
            icon="el-icon-download"
          >
            {{ item.name }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import http from "../../../APIService/http";
import moment from "moment";
import popedom from "./popedom";
import reportMonth from "./reportMonthCopy";

export default {
  name: "dataExport",
  data() {
    let that = this;
    return {
      date: "",
      month:"",
      endmonth:"",
      isManager: this.$store.getters.getUser.role !== "staff",
      showArr: [
        {
          name: "辖区签到",
          data: [
            {
              name: "辖区签到明细(医疗机构)",
              fileName: "辖区签到明细(医疗机构)",
              api: "/wapi/derive/exportTerritoryCheckin",
              params: {
                type: "INSTITUTION",
              },
            },
            {
              name: "辖区签到明细(零售门店)",
              fileName: "辖区签到明细(零售门店)",
              api: "/wapi/derive/exportTerritoryCheckin",
              params: {
                type: "RETAILSTORE",
              },
            },
            {
              name: "辖区签到明细(分销客户)",
              fileName: "辖区签到明细(分销客户)",
              api: "/wapi/derive/exportTerritoryCheckin",
              params: {
                type: "DISTRIBUTOR",
              },
            },
            {
              name: "辖区签到计划明细(医疗机构)",
              fileName: "辖区签到计划明细(医疗机构)",
              api: "/wapi/derive/exportTerritoryPlanCheckin",
            },
            {
              name: "辖区实际签到明细(含完整签到)",
              fileName: "辖区实际签到明细(含完整签到)",
              api: "/wapi/derive/exportTerritoryCheckin",
              params: {
                type: "INSTITUTION",
                complete:'T'
              },
            },
          ],
        },
        {
          name: "医务拜访",
          data: [
            {
              name: "拜访计划明细导出",
              fileName: "医务拜访计划明细(HCP)",
              api: "/wapi/derive/exportInstitutionPlan",
            },
            {
              name: "拜访实际明细导出",
              fileName: "拜访实际明细导出(HCP)",
              api: "/wapi/derive/exportInstitutionCall",
            },
            {
              name: "客户拜访覆盖统计",
              fileName: "客户拜访覆盖统计",
              api: "/wapi/derive/exportCoverage",
            },
            // {
            //   name: "拜访实际明细导出(含完整签到)",
            //   fileName: "医务拜访计录明细(含完整签到)",
            //   api: "/wapi/derive/exportInstitutionCall",
            //   params: {
            //     complete:'T'
            //   }
            // },
          ],
        },
        {
          name: "门店巡查",
          data: [
            {
              name: "巡店计划明细导出",
              fileName: "门店巡查计划明细",
              api: "/wapi/derive/exportRetailstorePlan",
            },
            {
              name: "巡店实际明细导出",
              fileName: "门店巡查计录明细",
              api: "/wapi/derive/exportRetailstoreCall",
            },
            // {
            //   name: "巡店实际明细导出(含完整签到)",
            //   fileName: "门店巡查计录明细(含完整签到)",
            //   api: "/wapi/derive/exportRetailstoreCall",
            //   params: {
            //     complete:'T'
            //   }
            // },
          ],
        },
        {
          name: "商务拜访",
          data: [
            {
              name: "拜访计划明细导出",
              fileName: "商务计划明细(联系人)",
              api: "/wapi/derive/exportDistributorPlan",
            },
            {
              name: "拜访实际明细导出",
              fileName: "商务计录明细(联系人)",
              api: "/wapi/derive/exportDistributorCall",
            },
            // {
            //   name: "拜访实际明细导出(含完整签到)",
            //   fileName: "商务计录明细(含完整签到)",
            //   api: "/wapi/derive/exportDistributorCall",
            //   params: {
            //     complete:'T'
            //   }
            // },
          ],
        },
        {
          name: "会议/活动",
          data: [
            {
              name: "会议活动实际明细导出",
              fileName: "会议活动记录明细",
              api: "/wapi/derive/exportCampaignRecord",
            },
            {
              name: "会议活动签到明细导出",
              fileName: "会议活动签到明细",
              api: "/wapi/derive/exportCampaignCheckin",
            },
            {
              name: "参会客户名单(HCP)",
              fileName: "参会客户名单(HCP)",
              api: "/wapi/derive/exportAttendClientHCP",
            },
            {
              name: "参会客户名单(店员)",
              fileName: "参会客户名单(店员)",
              api: "/wapi/derive/exportAttendClientClerk",
            },
            {
              name: "参会客户名单(联系人)",
              fileName: "参会客户名单(联系人)",
              api: "/wapi/derive/exportAttendClientContact",
            },
          ],
        },
        {
          name: "辅导/协访",
          data: [
            {
              name: "协访实际明细导出",
              fileName: "协访记录明细",
              api: "/wapi/derive/exportCoachingRecord",
            },
            {
              name: "协访签到明细导出",
              fileName: "协访签到明细",
              api: "/wapi/derive/exportCoachingCheckin",
            },
            {
              name: "协访相关医务拜访",
              fileName: "协访相关医务拜访记录明细(HCP)",
              api: "/wapi/derive/exportCoachingInstitutionCall",
            },
            {
              name: "协访相关门店巡查",
              fileName: "协访相关门店巡查记录明细",
              api: "/wapi/derive/exportCoachingStoreCall",
            },
            {
              name: "协访相关商务拜访",
              fileName: "协访相关商务拜访记录明细(联系人)",
              api: "/wapi/derive/exportCoachingDistributorCall",
            },
            {
              name: "协访评估表导出",
              fileName: "协访评估表导出",
              api: "/wapi/derive/exportCoachingFormItem",
            },

          ],
        },
        {
          name: "KPI数据",
          data: [
            {
              name: "机构KPI数据导出",
              fileName: "机构KPI统计",
              api: "/wapi/derive/exportInstitutionsKPI",
            },
            {
              name: "标准科室KPI数据",
              fileName: "标准科室KPI统计",
              api: "/wapi/derive/exportDepartmentKPI",
            },
            {
              name: "HCP拜访KPI数据",
              fileName: "目标HCP拜访KPI统计",
              api: "/wapi/derive/exportHCPcallKPI",
            },
            {
              name: "辅导协访KPI数据",
              fileName: "协访KPI统计",
              api: "/wapi/derive/exportCoachingKPI",
            },
            // {
            //   name: "辖区KPI数据导出",
            //   api: "",
            // },
          ],
        },
        {
          name: "其他数据",
          data: [
            {
              name: "差旅计划明细导出",
              fileName: "差旅计划明细",
              api: "/wapi/derive/exportTravel",
            },
            {
              name: "请假休假明细导出",
              fileName: "请假休假明细",
              api: "/wapi/derive/exportLeave",
            },
            {
              name: "内部事务明细导出",
              fileName: "内部事务明细",
              api: "/wapi/derive/exportInternal",
            },
          ],
        },
      ],
    };
  },
  components: {
    popedom,
    reportMonth,
  },
  created() {
    this.yearsDate = moment(this.GLOBAL.date).format("YYYY年MM月");
    debugger
  },
  methods: {
    async downloadDetail(api, params = {}, fileName) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let user = this.$store.getters.getUser;
      params.tenant_id = user.tenant_id;
      // if (this.GLOBAL.date) {
      //   debugger
      //   params.month = moment().format("YYYY-MM");
      // } else {
      //   params.month = "";
      // }
      debugger;
      params.month = this.month?this.month:moment().format("YYYY-MM");
      params.endmonth = this.endmonth?this.endmonth:moment().format("YYYY-MM");
      params.territory = this.GLOBAL.territory_id;
      debugger
      await axios({
        method: "post",
        url: api,
        data: params,
        responseType: 'arraybuffer'
        // responseType: "blob",
      })
        .then((res) => {
          // let uInt8Array = new Uint8Array(res.data); //先将返回的二进制数组转化为js的二进制数组
          // if (res.status !== 200) {
          //   loading.close();
          //   this.$message.error("下载失败");
          //   return;
          // }
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
          const elink = document.createElement("a");
          elink.download = fileName + params.month + ".xlsx";
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          loading.close();
        })
        .catch((e) => {
          loading.close();
          this.$message.error("下载失败");
        });
    },

    handleSelectInputClick() {
      // this.getData();
    },
    shelfData() {
      // this.getData();
    },
    handleSelectInput(date) {
      // this.date = j;
      this.month = moment(date[0]).format('YYYY-MM')
      this.endmonth = moment(date[1]).format('YYYY-MM')
    },
  },
};
</script>

<style scoped>
.header {
  border-bottom: 2px dotted rgb(231, 234, 236);
  padding-bottom: 20px;
}
.el-form {
  padding-bottom: 20px;
}
.el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/statement/components/dataExport.vue